// event.keyCode has been deprecated and replaced by event.key,
// however not all browsers implement it yet.

export var KEYBOARS_KEYS = {
  ARROW_DOWN: 'ArrowDown',
  ARROW_LEFT: 'ArrowLeft',
  ARROW_RIGHT: 'ArrowRight',
  ARROW_UP: 'ArrowUp',
  ENTER: 'Enter',
  TAB: 'Tab',
  ESCAPE: 'Escape',
  SPACE: ' ',
  HOME: 'Home',
  END: 'End'
};
export var isEnter = function isEnter(event) {
  return 'key' in event ? event.key === KEYBOARS_KEYS.ENTER : event.keyCode === 13;
};
export var isSpacebar = function isSpacebar(event) {
  return 'key' in event ? event.key === KEYBOARS_KEYS.SPACE : event.keyCode === 32;
};
export var isArrowLeft = function isArrowLeft(event) {
  return 'key' in event ? event.key === KEYBOARS_KEYS.ARROW_LEFT : event.keyCode === 37;
};
export var isArrowRight = function isArrowRight(event) {
  return 'key' in event ? event.key === KEYBOARS_KEYS.ARROW_RIGHT : event.keyCode === 39;
};
export var isArrowDown = function isArrowDown(event) {
  return 'key' in event ? event.key === KEYBOARS_KEYS.ARROW_DOWN : event.keyCode === 40;
};